// extracted by mini-css-extract-plugin
export default {"ButtonSection":"gridRotas_ButtonSection__QXlcY","UlCuston":"gridRotas_UlCuston__Yig6F"};